class DropdownMenu extends HTMLElement {
  constructor() {
    super()
    this.isOpen = false
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  connectedCallback() {
    this.querySelector('.dropdown-item').addEventListener('click', (e) => {
      e.stopPropagation()
      if (
        e.target !== this.querySelector('.dropdown-item .menu-item__link .item-image img') &&
        e.target !== this.querySelector('.dropdown-item .menu-item__link .item-title')
      ) {
        this.toggleDropdown()
      }
    })
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target) && this.isOpen) {
      this.closeDropdown()
    }
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  openDropdown() {
    this.isOpen = true
    this.classList.add('open')
  }

  closeDropdown() {
    this.isOpen = false
    this.classList.remove('open')
  }
}

customElements.define('dropdown-menu', DropdownMenu)
